const NewsletterSignup = {
	getElements() {
		this.$result = $('.js-newsletter-signup-result');
		this.$form = $('.js-newsletter-signup-form');
		this.$loader = $('.js-newsletter-signup-loader');
		this.$emailField = $('.js-newsletter-signup-email-field');
		this.$hpField = $('.js-newsletter-signup-hp-field');
		this.$nonceField = $('#_wpnonce');
	},
	submitForm(e) {
		const self = this;

		e.preventDefault();

		self.$loader.show();
		
		const data = {
			email: self.$emailField.val(),
			hp: self.$hpField.val(),
			action: 'newsletter_signup',
			_ajax_nonce: self.$nonceField.val(),
		};

		$.ajax({
	        type: 'POST',
	        url: ajaxurl,
	        data: data,
		}).done(result => {
			self.$loader.hide();
			const response = JSON.parse(result);
			if (response.status == 'success') {
				self.$result.show();
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					'event': 'newsletter_signup',
				});
			} else {
				self.handleError();
			}
		}).fail(() => {
			self.handleError();
		});
	},
	handleError() {
		const self = this;
		self.$loader.hide();
		alert('An error occurred - please check your details and try again!');
	},
	addEventListeners() {
		const self = this;

		self.$form.on('submit', self.submitForm.bind(self));
	},
	init() {
		this.getElements();
		this.addEventListeners();
	},
};

export default NewsletterSignup;
	